import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ClinicalSampleCnv from "../../../../../models/ClinicalSampleCnv";
import Track from "../../../models/Track";
import Region from "../../../../../models/Region";
import ZoomToRegion from "../../../components/TooltipActions/ZoomToRegion";
import SequenceView from "./SequenceView";

function BreakendInfo({ item, track, requestClose }) {
  const region = useMemo(() => {
    const start = Number(item?.breakendConnectedPos);
    const chrId = (item?.breakendConnectedChromo || "")
      .replace(/chr/i, "")
      .toLowerCase();
    const chr = track.zoomService.genome.keyMap.get(chrId);

    return !chr || Number.isNaN(start)
      ? null
      : new Region(start, start + 1, chr);
  }, [item, track.zoomService.genome.keyMap]);

  return (
    <>
      {region ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-32">Connected Position</div>
          <div className="tw-max-w-80">{region.readableStart || "-"}</div>
          <div className="tw-px-4">
            <ZoomToRegion
              originalRegion={item.region}
              requestClose={requestClose}
              region={region}
              jumpTo={track.zoomService.jumpTo}
            />
          </div>
        </div>
      ) : null}

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-32">Breakend Type</div>
        <div className="tw-max-w-80">{item?.breakendType}</div>
      </div>

      {item?.breakendInsertedSeq ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-32">Inserted Sequence</div>
          <div className="tw-max-w-80 tw-break-all">
            <SequenceView sequence={item?.breakendInsertedSeq} />
          </div>
        </div>
      ) : null}
    </>
  );
}

BreakendInfo.propTypes = {
  item: PropTypes.instanceOf(ClinicalSampleCnv).isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  requestClose: PropTypes.func.isRequired,
};

export default BreakendInfo;
